import React from "react";
import { Box, Typography, Fade } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { toleranciaMaximaPermitida } from "../../../../utils";

const toCentavos = (n) => Math.round((Number(n) || 0) * 100);
const fromCentavos = (n) => (Number(n) || 0) / 100;

export default function IndicadorFinalizacao({
  valor,
  subTotal,
  tipoPagamento,
  valorRecebido,
  resto,
}) {
  if (!tipoPagamento) {
    return null;
  }

  const valorNumber = Number(valor);

  if (Number.isNaN(valorNumber) || toCentavos(valorNumber) <= 0) {
    return null;
  }

  const valorCentavos = toCentavos(valorNumber);
  const subTotalCentavos = toCentavos(subTotal);
  const valorRecebidoCentavos = toCentavos(valorRecebido);
  const restoCentavos = toCentavos(resto);

  if (tipoPagamento.id === 1) {
    const toleranciaCentavos = toCentavos(toleranciaMaximaPermitida(subTotal));
    const limiteMaximoCentavos = subTotalCentavos + toleranciaCentavos;
    const limiteMinimoCentavos = subTotalCentavos - toleranciaCentavos;

    if (valorCentavos > limiteMaximoCentavos) {
      return null;
    }

    if (valorCentavos % 5 !== 0) {
      return null;
    }

    const trocoCentavos = valorRecebidoCentavos - valorCentavos;

    if (
      valorCentavos >= limiteMinimoCentavos &&
      valorCentavos <= limiteMaximoCentavos
    ) {
      return (
        <div>
          <MensagemEstado
            tipo="troco"
            Icone={CheckCircleIcon}
            texto={`Troco ${formatarMoeda(fromCentavos(trocoCentavos))}`}
          />
          <MensagemEstado
            tipo="sucesso"
            texto="Pode finalizar a venda"
            Icone={CheckCircleIcon}
          />
        </div>
      );
    }

    const faltamCentavos = subTotalCentavos - valorCentavos;

    return (
      <div>
        <MensagemEstado
          tipo="troco"
          Icone={CheckCircleIcon}
          texto={`Troco ${formatarMoeda(fromCentavos(trocoCentavos))}`}
        />
        <MensagemEstado
          tipo="aviso"
          texto={`Faltam ${formatarMoeda(fromCentavos(faltamCentavos))} para finalizar`}
          Icone={InfoOutlinedIcon}
        />
      </div>
    );
  } 

  if (valorCentavos === restoCentavos) {
    return (
      <MensagemEstado
        tipo="sucesso"
        texto="Pode finalizar a venda"
        Icone={CheckCircleIcon}
      />
    );
  }

  if (valorCentavos > restoCentavos) {
    return null;
  }

  const faltamCentavos = restoCentavos - valorCentavos;

  return (
    <MensagemEstado
      tipo="aviso"
      texto={`Faltam ${formatarMoeda(fromCentavos(faltamCentavos))} para finalizar`}
      Icone={InfoOutlinedIcon}
    />
  );
}

function MensagemEstado({ tipo, texto, Icone }) {
  const estilos = getEstilos(tipo);

  return (
    <Fade in>
      <Box
        mt={1}
        mb={2}
        display="flex"
        alignItems="center"
        style={{
          background: estilos.background,
          border: `1px solid ${estilos.borda}`,
          borderRadius: 4,
          padding: "8px 10px",
        }}
      >
        <Icone style={{ fontSize: 18, color: estilos.cor, marginRight: 8 }} />
        <Typography
          variant="body2"
          style={{
            color: estilos.cor,
            fontWeight: 500,
          }}
        >
          {texto}
        </Typography>
      </Box>
    </Fade>
  );
}

function getEstilos(tipo) {
  switch (tipo) {
    case "sucesso":
      return {
        cor: "#2e7d32",
        borda: "#81c784",
        background: "#edf7ed",
      };
    case "erro":
      return {
        cor: "#d32f2f",
        borda: "#ef9a9a",
        background: "#fdecec",
      };
    case "troco":
      return {
        cor: "#1565c0",
        borda: "#90caf9",
        background: "#e3f2fd",
      };
    default:
      return {
        cor: "#ed6c02",
        borda: "#ffcc80",
        background: "#fff4e5",
      };
  }
}

function formatarMoeda(valor) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor || 0);
}
